import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { connect } from "react-redux"
import { setUser, setRoles, setAuthenticated } from "../../redux/actions"
import { authApi } from "src/config"
import { local } from "brownies";

const AutoLoginFromCookies = ({
  children,
  setUser,
  setRoles,
  setAuthenticated,
}) => {
  const history = useHistory()
  const [loading, setLoading] = useState(true)

  const mainDashboardUrl = new URL(process.env.REACT_APP_NAVIGATION_URL)
  const env = process.env.REACT_APP_COOKIE_DOMAIN

  const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(";").shift()
    }
    return null
  }

  const redirectToMainDashboard = () => {
    window.open(mainDashboardUrl.toString(), "_self")
  }

  useEffect(() => {
    const runAutoLogin = async () => {
      try {
        const rawUserData = getCookie(`user_data_${env}`)

        if (!rawUserData) {
          alert("No user data cookie found. Redirecting to main dashboard...")
          console.warn("No user data cookie found. Redirecting...")
          // setTimeout(() => {
          //   redirectToMainDashboard()
          // }, 8000)
          redirectToMainDashboard()
          return
        }

        let parsedUser

        try {
          parsedUser = JSON.parse(
            decodeURIComponent(rawUserData).replace(/^"|"$/g, "")
          )
        } catch (e) {
          alert("Failed to parse user data cookie. Redirecting to main dashboard...")
          console.error("Failed to parse user_data cookie:", e)
          // setTimeout(() => {
          //   redirectToMainDashboard()
          // }, 8000)
          redirectToMainDashboard()
          return
        }

        const checkUserSession = await authApi.get("/api/v1/auth/me")
        
        if (checkUserSession.status !== 200) {
          
          console.warn("User session is not valid. Redirecting...")
          alert("User session is not valid. Redirecting to main dashboard...")
          // setTimeout(() => {
          //   redirectToMainDashboard()
          // }, 8000)
          redirectToMainDashboard()
          return
        }

        const dashboards = checkUserSession.data?.dashboards ?? []
        if (checkUserSession.data.isAdmin !== true && !dashboards.includes("tts")) {
          alert("User does not have access to TTS dashboard. Redirecting to main dashboard...")
          console.warn("User does not have access to TTS dashboard. Redirecting...")
          // setTimeout(() => {
          //   redirectToMainDashboard()
          // }, 8000)
          redirectToMainDashboard()
          return
        }

        setAuthenticated(true)

        setUser({
          email: parsedUser.userEmail,
          name: parsedUser.userName,
          lastName: parsedUser.userLastName,
          dashboards: checkUserSession.data?.dashboards ?? [],
          isAdmin: checkUserSession.data?.isAdmin === true,
        })

        setRoles(parsedUser.roles || [])

        local.expires_in = 60;

        if (window.location.pathname === "/") {
          history.replace("/profile")
        } else {
          history.replace(window.location.pathname)
        }
      } catch (error) {
        
        console.error("Auto login failed:", error)
        alert("Auto login failed. Redirecting to main dashboard...")
        // setTimeout(() => {
        //   redirectToMainDashboard()
        // }, 10000)
        redirectToMainDashboard()
      } finally {
        setLoading(false)
      }
    }

    runAutoLogin()
  }, [history, setUser, setRoles, setAuthenticated])

  if (loading) return <p>Loading...</p>

  return children
}

export default connect(null, {
  setUser,
  setRoles,
  setAuthenticated,
})(AutoLoginFromCookies)
